// Anzeige-Labels & Farben pro Kategorie
export const CATEGORY_META = {
  basis: { label: 'Basis', color: 'bg-yellow-500/15 text-yellow-400 border-yellow-500/30' },
  pv: { label: 'Photovoltaik', color: 'bg-orange-500/15 text-orange-400 border-orange-500/30' },
  smart_home: { label: 'Smart Home', color: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30' },
  buero: { label: 'Büro', color: 'bg-sky-500/15 text-sky-400 border-sky-500/30' },
  ki_handwerk: { label: 'KI im Handwerk', color: 'bg-fuchsia-500/15 text-fuchsia-400 border-fuchsia-500/30' } };

export const PACKAGE_LABEL = {
  basis: 'Basis-Paket',
  pv: 'PV-Paket',
  smart_home: 'Smart-Home-Paket',
  buero: 'Büro-Paket',
  ki_handwerk: 'KI-Paket' };
